const paths = {
  back: "M19 12H5m7 7-7-7 7-7",
  check: "m5 12 4 4L19 6",
  link: "M10 13a5 5 0 0 0 7 0l4-4a5 5 0 0 0-7-7l-2 2M14 11a5 5 0 0 0-7 0l-4 4a5 5 0 0 0 7 7l2-2",
  search: "M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
  plus: "M12 5v14M5 12h14",
  trash: "M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7",
  upload: "M12 16V3m-5 5 5-5 5 5M4 14v6h16v-6",
  clock: "M12 8v5l3 2M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z",
  printer: "M6 8V3h12v5M6 17H3V8h18v9h-3M6 14h12v7H6ZM17 11h1",
  chevron: "m9 5 7 7-7 7",
  close: "m6 6 12 12M6 18 18 6",
  home: "m3 10 9-7 9 7M5 9v12h5v-7h4v7h5V9",
  calculator: "M5 2h14v20H5ZM8 6h8M8 11h1m6 0h1M8 15h1m6 0h1M8 18h1m6 0h1",
  receipt: "M5 3h10l4 4v14H5ZM14 3v5h5M8 12h8M8 16h5",
  history: "M3 11a9 9 0 1 1 2 7M3 4v7h7M12 7v5l4 2",
  box: "m12 3 9 5v9l-9 5-9-5V8Zm0 10 9-5M12 13 3 8m9 5v9M7.5 5.5l9 5",
  user: "M20 21v-2a7 7 0 0 0-14 0v2M17 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  card: "M3 5h18v14H3ZM3 10h18M7 15h3",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Zm13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  hidden: "m3 3 18 18M10 5c6-1 12 7 12 7s-1 2-4 4M6 6c-3 2-4 6-4 6s4 7 10 7c2 0 3-1 4-1",
};

export function CalcIcon({ name, size = 18, ...props }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}><path d={paths[name] || paths.plus} /></svg>;
}
